import { w as o } from "./index760.mjs";
var a = o, t = a("match"), m = function(e) {
  var r = /./;
  try {
    "/./"[e](r);
  } catch {
    try {
      return r[t] = !1, "/./"[e](r);
    } catch {
    }
  }
  return !1;
};
export {
  m as c
};
